// extracted by mini-css-extract-plugin
export default {"divShake":"PurchaseDivTest_divShake__aAT3j","horizontal-shaking":"PurchaseDivTest_horizontal-shaking__Wk8W3"};